// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"5631ccf2","574":"2e0dfce0","673":"ee230943","787":"b875cc9e","804":"61b262e9"}[chunkId] + ".chunk.js";
};